import React from 'react';

import { Translate } from 'react-localize-redux';

import { NotificationTemplateName } from '@common/types/notifications/notification-template-name';

import Typography from '@components/basics/typography';

export default function getNotificationText(
  type: NotificationTemplateName,
  data: {
    releaseName?: string;
    userName?: string;
    songName?: string;
    reasons?: string;
    subject?: string;
  }
) {
  const getBoldText = (text: React.ReactNode) => {
    return <Typography weight="700">{text}</Typography>;
  };

  const getText = (text: React.ReactNode) => {
    return <Typography>{text}</Typography>;
  };

  switch (type) {
    case 'release-denied':
      return (
        <>
          {getBoldText(data.releaseName)}
          &nbsp;
          {getText(<Translate id="NOTIFICATION.RELEASE_DENIED" />)}
          &nbsp;
          {getBoldText(
            <Translate
              id="NOTIFICATION.RELEASE_DENIED_REASON"
              data={{ REASON: data.reasons }}
            />
          )}
        </>
      );
    case 'release-in-review':
      return (
        <>
          {getText(<Translate id="NOTIFICATION.RELEASE_IN_REVIEW" />)}
          &nbsp;
          {getBoldText(data.releaseName)}
          &nbsp;
        </>
      );
    case 'release-accepted-others':
      return (
        <>
          {getBoldText(data.releaseName)}
          &nbsp;
          {getText(<Translate id="NOTIFICATION.RELEASE_ACCEPTED_OTHERS" />)}
          &nbsp;
        </>
      );
    case 'invite-team':
      return (
        <>
          {getBoldText(data.userName)}
          &nbsp;
          {getText(<Translate id="NOTIFICATION.RELEASE_INVITE_TEAM" />)}
          &nbsp;
        </>
      );
    case 'invite-credits':
      return (
        <>
          {getText(<Translate id="NOTIFICATION.RELEASE_INVITE_CREDITS.1" />)}
          &nbsp;
          {getBoldText(data.songName)}
          &nbsp;
          {getText(<Translate id="NOTIFICATION.RELEASE_INVITE_CREDITS.2" />)}
          &nbsp;
        </>
      );

    case 'sync-opportunity':
      return (
        <>
          {getBoldText(<Translate id="NOTIFICATION.SYNC_NOTIFICATION.TITLE" />)}
          &nbsp;
          {getText(data.subject)}
        </>
      );

    default:
      break;
  }
}
